/**
 * The feature catalog as the public site shows it (build F8): cut and hidden
 * features are removed from navigation, the features index and group pages.
 * The pages themselves still exist until the Phase 2 redirects ship.
 *
 * Cut: Daily Pulse, collections, trash service. Hidden: Acquisitions, Buy,
 * renovation/furnishing/launch trackers, sale listings, vendor marketplace,
 * Reviews (backend D21).
 */
import { featureCatalog, type FeatureGroup, type SubFeature } from "@/data/feature-catalog";

export const HIDDEN_FEATURE_PATHS: ReadonlySet<string> = new Set([
  "pipeline/acquisitions",
  "pipeline/buy",
  "pipeline/renovate",
  "pipeline/furnish",
  "pipeline/launch",
  "operations/trash-service",
  "revenue/collections",
  "revenue/sell",
  "vendors/vendor-marketplace",
  // Backend D21: Reviews is hidden.
  "members/reviews",
]);

export function isFeatureVisible(groupSlug: string, featureSlug: string): boolean {
  return !HIDDEN_FEATURE_PATHS.has(`${groupSlug}/${featureSlug}`);
}

export function visibleSubFeatures(group: FeatureGroup): SubFeature[] {
  return group.subFeatures.filter((sf) => isFeatureVisible(group.slug, sf.slug));
}

/** Groups with only their visible sub-features (groups left empty are dropped). */
export const marketingFeatureCatalog: FeatureGroup[] = featureCatalog
  .map((group) => ({ ...group, subFeatures: visibleSubFeatures(group) }))
  .filter((group) => group.subFeatures.length > 0);

export const marketingFeatureCount = marketingFeatureCatalog.reduce(
  (acc, g) => acc + g.subFeatures.length,
  0,
);
